import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { InventoryContext } from './inventory.context';
import { VIEW_LOTS_PERMISSIONS, VIEW_TRANSACTIONS_PERMISSIONS } from '../shared/auth/permissions';
import { HELP_MANAGE_INVENTORY } from '../app.constants';
import { HelpService } from '../shared/service/help.service';
import { BmsjHipsterSharedModule } from '../shared';
import { InventoryManagerLotModule } from '../entities/lot/lot.module';
import { InventoryManagerTransactionModule } from '../entities/transaction/transaction.module';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';
import { ParamContext } from '../shared/service/param.context';
import { SubscriptionsManager } from '../shared/util/subscriptions-manager';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'jhi-inventory-manager',
    templateUrl: './inventory-manager.component.html',
    styles: []
})
export class InventoryManagerComponent implements OnDestroy {

    protected readonly HELP_MANAGE_INVENTORY = HELP_MANAGE_INVENTORY;
    VIEW_LOTS_PERMISSIONS = VIEW_LOTS_PERMISSIONS;
    VIEW_TRANSACTIONS_PERMISSIONS = VIEW_TRANSACTIONS_PERMISSIONS;
    helpLink: string;
    subscriptionManager = new SubscriptionsManager();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private inventoryContext: InventoryContext,
        private helpService: HelpService,
        private paramContext: ParamContext) {

        // Subscribe to router events to detect when component is navigated to again
        this.subscriptionManager.add = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            // Only trigger for the root inventory manager route
            filter((event: NavigationEnd) => {
                return !event.url.includes('inventory-manager-outlet');
            })
        ).subscribe(() => {
            // Load lot tab when navigating to root path of Inventory Manager
            this.router.navigate(
                [{ outlets: { 'inventory-manager-outlet': ['lot'] } }],
                { relativeTo: this.route, queryParamsHandling: 'preserve' }
            );
        });


        this.paramContext.readParams();

        const queryParams = this.route.snapshot.queryParams;

        // set common params once upon first page load
        // to avoid having to repeat them on every route
        if (!this.inventoryContext.cropName) {
            this.inventoryContext.cropName = queryParams.cropName;
        }
        if (!this.inventoryContext.programUUID) {
            this.inventoryContext.programUUID = queryParams.programUUID;
        }
        if (!this.inventoryContext.selectedProjectId) {
            this.inventoryContext.selectedProjectId = queryParams.selectedProjectId;
        }
        if (!this.inventoryContext.loggedInUserId) {
            this.inventoryContext.loggedInUserId = queryParams.loggedInUserId;
        }

        // Get helplink url
        if (!this.helpLink || !this.helpLink.length) {
            this.helpService.getHelpLink(HELP_MANAGE_INVENTORY).toPromise().then((response) => {
                this.helpLink = response.body;
            }).catch((error) => {});
        }

    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

}
